import * as gtm from '../gtm';

// BBS DDD 2018-03-08 Shim IE
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

(function ($) {
    $(document).ready(function () {

        var pageContainerSelector = '.js-product-page';
        var pageContainer = $(pageContainerSelector);
        var allCarouselsInited = false;

        if ($('.js-product-page').length > 0) {
            var topOfStickyBar = $('.sticky-bar-wrapper').position().top;

            $(document).scroll(() => {

                var pos = $(window).scrollTop();
                const $overlay = $('.product-sticky-header');

                if ($overlay.length) {
                    // If the user is scrolled past the sticky point when the page loads, the expected top may be higher than it should be
                    let newTopOfStickyBar = $('.sticky-bar-wrapper').position().top;
                    if (newTopOfStickyBar < topOfStickyBar) {
                        topOfStickyBar = newTopOfStickyBar;
                    }

                    const posOffset = topOfStickyBar - 100; // 100 is the height of the product sticky header

                    if (pos >= posOffset && !$("#typeahead-mobile-wrapper").is(":visible")) {
                        $('#header').addClass('js-header--hide');
                        $('.product-sticky-header').addClass('product-sticky-header--scrolled');
                    } else {
                        $('#header').removeClass('js-header--hide');
                        $('.product-sticky-header').removeClass('product-sticky-header--scrolled');
                    }
                }

            });
        }

        // change variant info when you select a variant
        $(document).on("change", pageContainerSelector + " #variationsSelect", function () {
            if (!window.variations)
                return;

            var code = $(this).val();
            selectVariationByCode(code);
        });

        $(document).on("click", "#more-info-link", function (event) {
            event.preventDefault();
            var scrollTop = $("#more-info-wrapper").offset().top - $(".header-botom-top-wrapper").height();
            $("body,html").animate({ scrollTop: scrollTop }, 200);
        });

        if (window.gtmProducts && window.gtmProducts.length > 0) {
            gtm.productDetail(window.gtmProducts); // TODO: Remove old GA
            gtm.viewProduct(window.gtmProducts);
        }

        if (window.gtmRelatedProducts && window.gtmRelatedProducts.length > 0) {
            gtm.viewItemList(window.gtmRelatedProducts, "RelatedProducts");
        }

        if (!!window.variations && window.variations.length > 0) {
            initCarouselNav();

            if (window.location.search.includes('min=')) {
                let urlParams = new URLSearchParams(window.location.search);
                let min = urlParams.get('min').toLowerCase();
                let selectedVariation = window.variations.find((v) => { return v.MasterItemNumber.toLowerCase() === min });
                if (!!selectedVariation) {
                    $(pageContainerSelector + " #variationsSelect").val(selectedVariation.Code);
                    selectVariationByCode(selectedVariation.Code);
                }
            } else {
                HandleAddToCartIfApplicable(); // For the other case, it's handled in selectVariationByCode
            }
        }

        function initCarouselNav() {
            if (!!$("product-details__body .carousel-nav").flickity) {
                for (var i = 0; i < window.variations.length; i++) {
                    if (!window.variations[i].CarouselMainMobileCells) {
                        window.variations[i].CarouselMainMobileCells = $('.product-details__body .carousel-main__mobile .carousel-cell[data-variation="' + window.variations[i].SKU + '"]').clone();
                        window.variations[i].CarouselMainMobileCells.removeClass('is-selected');
                        window.variations[i].CarouselMainMobileCells.css('position', '');
                        window.variations[i].CarouselMainMobileCells.css('left', '');
                    }
                }

                hideVariantImagesAndShowIndex(0);
            } else {
                setTimeout(initCarouselNav, 100);
            }
        }

        function selectVariationByCode(code) {
            pageContainer.find(".js-price-wrapper").addClass("d-none");
            //pageContainer.find(".variation-details").addClass("d-none");

            for (var i = 0; i < window.variations.length; i++) {
                if (window.variations[i].Code === code) {
                    const variation = window.variations[i];
                    const $jsVariation = pageContainer.find(".js-addtocart-code");
                    $jsVariation.data("code", code);

                    const stepQuantity = variation.EnforceCaseCount ? variation.CaseCount : 1;
                    const minimumOrderQuantity = Math.max(variation.MinimumOrderQuantity, 1, stepQuantity);

                    const $qty = $jsVariation.find("#Qty");
                    if ($qty) {
                        $qty.attr({ "min": minimumOrderQuantity });
                        $qty.attr({ "step": stepQuantity });
                        $qty.val(minimumOrderQuantity);
                    }

                    if (minimumOrderQuantity > stepQuantity) {
                        pageContainer.find(".js-product-min-quantity-msg").removeClass("d-none");
                    } else {
                        pageContainer.find(".js-product-min-quantity-msg").addClass("d-none");
                    }
                    pageContainer.find(".js-min-quantity").html(variation.MinimumOrderQuantity);
                    pageContainer.find(".product-sticky-header input[name='Qty']").val(minimumOrderQuantity);

                    if (stepQuantity > 1) {
                        pageContainer.find(".js-casecount-quantity").html(stepQuantity);
                        pageContainer.find(".js-product-casecount-quantity-msg").removeClass("d-none");
                    } else {
                        pageContainer.find(".js-product-casecount-quantity-msg").addClass("d-none");
                    }

                    if (!variation.HidePrice) {
                        pageContainer.find("#price-wrapper-" + code).removeClass("d-none");
                        pageContainer.find("#sticky-price-wrapper-" + code).removeClass("d-none");
                    }

                    //$("#variation-details-" + code).removeClass("d-none");

                    const specificationsTable = pageContainer.find("table.js-specifications");
                    specificationsTable.find("tr:gt(0)").remove();

                    variation.Specifications.forEach(specification =>
                        specificationsTable.append('<tr><td>' + specification["Name"] + '</td><td>' + specification["Value"] + '</td></tr>')
                    )

                    pageContainer.find(".js-item-number").text(variation.SKU);
                    pageContainer.find(".js-catalog-number").text(variation.CatalogNumber);
                    pageContainer.find(".js-catalog-number-wrapper").toggleClass('d-none', !variation.CatalogNumber);

                    const inStock = pageContainer.find(".js-in-stock");
                    const outOfStock = pageContainer.find(".js-out-of-stock");
                    const expectAvailability = pageContainer.find(".js-expect-availability");
                    const expectAvailabilityText = pageContainer.find(".js-expect-availability-text");

                    if (variation.InStock) {
                        inStock.removeClass('d-none');
                        outOfStock.addClass('d-none');
                        expectAvailability.addClass('d-none');
                    } else {
                        inStock.addClass('d-none');
                        outOfStock.removeClass('d-none');

                        expectAvailability.removeClass('d-none');
                        let expectAvailabilityString = expectAvailability.attr('data-expect-availability');
                        if (variation.BackorderAvailabilityDate) {
                            expectAvailabilityString = expectAvailability.attr('data-expect-availability-date-format')
                                .replace('{0}', variation.BackorderAvailabilityDate);
                        };
                        expectAvailabilityText.text(expectAvailabilityString);
                    }

                    const onlyIfSellable = pageContainer.find(".js-add-to-cart-panel");
                    const notSellableMsgVariant = pageContainer.find(".js-variation-not-sellable-msg");
                    const notSellableMsgLinkWrapperVariant = pageContainer.find(".js-variation-not-sellable-msg-link-wrapper");
                    const notSellableMsgLinkVariant = pageContainer.find(".js-variation-not-sellable-msg-link");
                    if (variation.IsSellable) {
                        onlyIfSellable.removeClass('d-none');

                        notSellableMsgVariant.addClass('d-none');
                        notSellableMsgVariant.html("");

                        notSellableMsgLinkWrapperVariant.addClass('d-none');
                        notSellableMsgLinkVariant.html("");
                        notSellableMsgLinkVariant.attr('href', "");
                    } else {
                        onlyIfSellable.addClass('d-none');

                        notSellableMsgVariant.removeClass('d-none');
                        notSellableMsgVariant.html(variation.NotSellableMessage);

                        notSellableMsgLinkWrapperVariant.removeClass('d-none');
                        notSellableMsgLinkVariant.html(variation.ReasonNotSaleableLinkText);
                        notSellableMsgLinkVariant.attr('href', variation.ReasonNotSaleableLinkUrl);
                        notSellableMsgLinkVariant.attr('target', variation.ReasonNotSaleableLinkOpensNewTab ? "_blank" : "_self");
                    }

                    const notPurchaseablebyMsgVariant = pageContainer.find(".js-variation-not-purchaseableby-msg");
                    const notPurchaseablebyMsgLinkVariant = pageContainer.find(".js-variation-not-purchaseableby-msg-link");

                    if (variation.IsPurchaseableByAccount) {
                        notPurchaseablebyMsgLinkVariant.html("");
                        notPurchaseablebyMsgLinkVariant.attr('href', "");
                        notPurchaseablebyMsgVariant.addClass('d-none');
                    } else {
                        notPurchaseablebyMsgLinkVariant.html(variation.ReasonNotPurchasableByLinkText);
                        notPurchaseablebyMsgLinkVariant.attr('href', variation.ReasonNotPurchasableByLinkUrl);
                        notPurchaseablebyMsgLinkVariant.attr('target', variation.ReasonNotPurchasableByLinkOpensNewTab ? "_blank" : "_self");
                        notPurchaseablebyMsgVariant.removeClass('d-none');
                    }

                    const stockInfo = pageContainer.find(".js-stock");
                    if (variation.ShowInventoryAvailable && variation.IsSellable) {
                        stockInfo.removeClass('d-none');
                    } else {
                        stockInfo.addClass('d-none');
                    }

                    if (variation.IsPurchaseableByAccount && variation.IsSellable) {
                        onlyIfSellable.removeClass('d-none');
                    } else {
                        onlyIfSellable.addClass('d-none');
                    }

                    const whereToBuyButton = pageContainer.find(".js-variation-wheretobuy");
                    whereToBuyButton.toggleClass('d-none', !variation.WhereToBuyEnabled);
                    // We don't know if the widget will read data or attr, but they can return different values, so update them both.
                    if (variation.SKU) {
                        whereToBuyButton.find('span[data-gh-mpn-code]').data("GhMpnCode", variation.SKU);
                        whereToBuyButton.find('span[data-gh-mpn-code]').attr("data-gh-mpn-code", variation.SKU);
                        whereToBuyButton.find('span[data-gh-ean-code]').data("GhEanCode", "");
                        whereToBuyButton.find('span[data-gh-ean-code]').attr("data-gh-ean-code", "");
                    } else {
                        whereToBuyButton.find('span[data-gh-ean-code]').data("GhEanCode", variation.UPC);
                        whereToBuyButton.find('span[data-gh-ean-code]').attr("data-gh-ean-code", variation.UPC);
                        whereToBuyButton.find('span[data-gh-mpn-code]').data("GhMpnCode", "");
                        whereToBuyButton.find('span[data-gh-mpn-code]').attr("data-gh-mpn-code", "");
                    }
                    hideVariantImagesAndShowIndex(i);

                    HandleAddToCartIfApplicable();

                    if (!!history.replaceState) {
                        let newUrl = new URL(window.location);
                        newUrl.searchParams.set('min', variation.MasterItemNumber);
                        newUrl = newUrl.toString();
                        history.replaceState({ path: newUrl }, '', newUrl);
                    }

                    UpdateLoginRedirects();

                    break;
                }
            }
        }

        function checkCarouselsFlickity() {
            if (!allCarouselsInited) {
                if (!!$("product-details__body .carousel-main__mobile").flickity) {
                    allCarouselsInited = true;
                }
            }
            return allCarouselsInited;
        }

        function hideVariantImagesAndShowIndex(index) {
            if (checkCarouselsFlickity()) {
                const windowVariation = window.variations[index];
                $('.product-details__body .carousel-main__mobile').flickity('remove', $('.product-details__body .carousel-main__mobile .carousel-cell[data-variation]'));

                if (windowVariation.CarouselMainMobileCells.length > 0) {
                    $('.product-details__body .carousel-main__mobile').flickity('prepend', windowVariation.CarouselMainMobileCells.clone())
                    $('.product-details__body .carousel-main__mobile').flickity('selectCell', 0);
                }

                // Update Carousel
                var cellsShown = 0;
                $('.product-details__body .product-carousel-nav .image-cell').each((i, el) => {
                    const e = $(el);
                    if (cellsShown >= 4 || (!!e.attr('data-variation') && e.attr('data-variation') !== windowVariation.SKU)) {
                        e.addClass('d-none');
                    } else {
                        e.removeClass('d-none');
                        cellsShown++;
                        e.children('span').toggleClass('d-none', cellsShown < 4)
                        e.children('i').toggleClass('d-none', cellsShown >= 4)
                    }
                });
                const firstImage = $('.product-details__body .product-carousel-nav .image-cell:not(.d-none)').first();
                const mainImageAndZoomButton = $('.product-details__body .main-image__cell, .product-details__body .main-image__cell .product-gallery__zoom-button');
                $('.product-details__body .main-image__cell').css('background-image', `url('${firstImage.attr('data-image-url')}')`);
                mainImageAndZoomButton.data('slideModalUrl', firstImage.attr('data-image-url'));
                mainImageAndZoomButton.data('slideModalAlt', firstImage.attr('data-image-alt-text'));
                mainImageAndZoomButton.attr('data-image-url', firstImage.attr('data-image-url'));

                // Update Modal
                $('.js-image-modal .js-image-cell-modal[data-variation]').addClass('d-none');
                $(`.js-image-modal .js-image-cell-modal[data-variation='${windowVariation.SKU}']`).removeClass('d-none');
            } else {
                setTimeout(function () { hideVariantImagesAndShowIndex(index); }, 100);
            }
        }

        function UpdateLoginRedirects() {
            const baseLoginUrl = $('.js-product-page').data('loginbaseurl');

            $('.js-login-link').each((i, e) => {
                let returnUrl = new URL(window.location);
                if ($(e).hasClass('js-login-link-addtocart')) {
                    returnUrl.searchParams.set('addtocart', 'true');
                }
                $(e).attr('href', baseLoginUrl + "?ReturnUrl=" + encodeURIComponent(returnUrl.pathname + returnUrl.search));
            });
        }

        function HandleAddToCartIfApplicable() {
            if (!!(new URLSearchParams(window.location.search)).get('addtocart')) {
                //$('#addToShoppingCartForm').submit();
                $('.product-actions .btn-add-to-cart').trigger('click');

                let newUrl = new URL(window.location);
                newUrl.searchParams.delete('addtocart');
                newUrl = newUrl.toString();
                window.history.replaceState({ path: newUrl }, '', newUrl);
            }
            UpdateLoginRedirects();
        }
        addLoginClickEvent();
    });
    function addLoginClickEvent() {
        $("a.js-login-link").on("click.addLoginClickEvent", function () {
                gtm.addtoDataLayerLoginClick('product detail page');
        });
    }
})($);